import {
    faEnvelope,
    faPaperPlane,
    faZ,
} from '@fortawesome/free-solid-svg-icons';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { linkgroup } from '../pages/Home/JoinGroupV2';
import { APP_LINKS } from '../constants/app-links';

// Badge tải app 2 dòng (chuẩn App Store / Google Play) cho Footer.
function FooterStoreBadge({ href, icon, top, bottom }) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label={`Tải Longhousee trên ${bottom} (mở tab mới)`}
            className="flex items-center gap-2 bg-black hover:bg-gray-900 text-white rounded-xl pl-3 pr-4 py-2 active:scale-95 transition-all shadow"
        >
            <FontAwesomeIcon icon={icon} className="text-2xl" />
            <span className="flex flex-col leading-tight text-left">
                <span className="text-[9px] opacity-80">{top}</span>
                <span className="text-sm font-bold -mt-0.5">{bottom}</span>
            </span>
        </a>
    );
}

function FooterV2() {
    return (
        <div className="bg-gradient-to-br from-brand-coral to-brand-warm pt-6">
            <div className="text-center text-white">
                <div className="flex justify-center items-center">
                    <div className="w-20 aspect-square">
                        <img
                            src="img/brand-logo/longhousee.png"
                            alt="logolonghousee"
                        />
                    </div>
                    <div className="font-lexend flex flex-col justify-center items-center font-bold">
                        <span className="px-2">SĂN SALE CÙNG</span>
                        <span className="px-1">LONGHOUSEE</span>
                    </div>
                </div>
                <p className="font-semibold text-sm p-4">
                    Mua sắm thông minh, hoàn tiền cực đã
                </p>
            </div>
            <div className="py-2 px-2 mx-6 rounded-t-lg bg-surface flex justify-between items-center gap-1 md:px-4">
                <div className="flex gap-1 justify-center items-center text-sm">
                    <div className="w-5 h-5 rounded-full bg-black text-white text-xs flex justify-center items-center">
                        <FontAwesomeIcon
                            icon={faEnvelope}
                            className="text-xs"
                        />
                    </div>
                    <span className="font-semibold text-[8px] md:text-base">
                        longhousee@gmail.com
                    </span>
                </div>
                <div className="flex gap-1 justify-center items-center text-sm">
                    <div className="w-5 h-5 rounded-full bg-black text-white text-xs flex justify-center items-center">
                        <FontAwesomeIcon
                            icon={faPaperPlane}
                            className="text-xs"
                        />
                    </div>
                    <Link
                        to={linkgroup.telegram}
                        className="font-semibold text-[8px] md:text-base hover:underline"
                    >
                        {linkgroup.telegram.replace('https://', '')}
                    </Link>
                </div>
                <div className="flex gap-1 justify-center items-center text-sm">
                    <div className="w-5 h-5 rounded-full bg-black text-white text-xs flex justify-center items-center">
                        <FontAwesomeIcon icon={faZ} className="text-xs" />
                    </div>
                    <Link
                        to={linkgroup.zalo}
                        className="font-semibold text-[8px] md:text-base hover:underline"
                    >
                        {linkgroup.zalo.replace('https://', '')}
                    </Link>
                </div>
            </div>
            <div className="mx-6 bg-surface border-t border-line px-3 py-3">
                <p className="text-center text-xs font-semibold text-content-2 mb-2">
                    Tải App Longhousee
                </p>
                <div className="flex flex-wrap items-center justify-center gap-2">
                    <FooterStoreBadge
                        href={APP_LINKS.ios}
                        icon={faApple}
                        top="Tải về trên"
                        bottom="App Store"
                    />
                    <FooterStoreBadge
                        href={APP_LINKS.android}
                        icon={faGooglePlay}
                        top="Tải về trên"
                        bottom="Google Play"
                    />
                </div>
            </div>
            <div className="mx-6 bg-surface border-t border-line px-3 py-2 rounded-b-lg">
                <div className="flex items-center justify-center gap-3 text-xs md:text-sm text-content-2">
                    <Link to="/support" className="hover:underline">
                        Hỗ trợ
                    </Link>
                    <span>|</span>
                    <Link to="/privacy" className="hover:underline">
                        Chính sách bảo mật
                    </Link>
                    <span>|</span>
                    <Link to="/terms" className="hover:underline">
                        Điều khoản sử dụng
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default FooterV2;
